<template>
  <section class="block fee-panel">
    <van-cell :title="title" :label="label" class="block_header panel-title" 
     :is-link="link"  @click="click()">
      <span class="panel-title-value">{{value}}</span>
    </van-cell>
    <template v-for="fee of fees">
      <van-cell
        :title="fee.title"
        :border="false"
        class="panel-title-fee"
        v-bind:key="fee.title+'_title'"
      >
      <template v-if="fee.status">
        <span class="fee-text " v-bind:class="'status-' + fee.status.stat ">{{fee.total}}</span>
        <span class="margin-left-5" >
          <van-tag plain type="danger" v-if="fee.status.text" v-bind:class="'status-' + fee.status.stat ">{{ fee.status.text }}</van-tag>
        </span>
        </template>
      </van-cell>
      <div class="payment-panel-container" v-bind:key="fee.title+'_container'">
        <div class="sby-panel-item" v-for="item of fee.items" v-bind:key="item.title">
          <div class="van-cell__title">
            <span>{{item.title}}</span>
          </div>
          <div class="van-cell__value" @click="showAmtDetail(fee.title + item.title, item.items, item.value)">
            <span>{{item.value}}</span>
            <span class="margin-left-2 text-gray">元</span>
            <van-icon name="info-o" class="cell-right-icon" v-if="item.items"/>
          </div>
        </div>
      </div>
    </template>
    <div class="clear"></div>

    <!-- 费用详情 -->
    <van-dialog
      v-model="showAmtDetailDialog"
      :title="`${payment_way_desc}${detailTitle}明细`"
      confirmButtonText="确认"
      class="fee-detail-dialog"
    >
      <van-list>
        <van-cell
          v-for="item in amtDetailItems"
          :key="item.name+item.amt"
          :title="item.name"
          v-if="!item.seq"
          :value="typeof(item.amt) === 'number' ? item.amt + ' 元' : item.amt"
        />

        <van-cell
          class="sep-detail-item"
          v-for="item in amtDetailItems"
          :key="item.name+item.amt"
          :title="item.name"
          v-if="item.seq"
          :value="typeof(item.amt) === 'number' ? item.amt + ' 元' : item.amt"
         />

        <van-cell v-if="detailTotal >= 0">
          <template>
            <div style="text-align:right;">合计缴费：{{detailTotal}}元</div>
          </template>
        </van-cell>
      </van-list>
    </van-dialog>


  </section>
</template>

<script>
import _ from "lodash";
import { Toast, version, Dialog, Tag } from "vant";

export default {
  name: "sby-price-panel",
  props: {
    label: {
      type: String
    },
    value: {
      type: String
    },
    link: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },

    fees: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  model: {
    event: "change"
  },
  data() {
    return {
      showAmtDetailDialog: false,
      amtDetailItems: [],
      payment_way_desc: '',
      detailTitle: '',
      detailTotal: 0,
    };
  },
  mounted() {},
  watch: {},
  methods: {
    showAmtDetail(title, items, detailTotal) {
      this.detailTitle = title;
      this.showAmtDetailDialog = true;
      this.amtDetailItems = items;
      this.detailTotal = detailTotal;
    },
    click() {
      this.$emit('click');
    }
  }
};
</script>
<style lang="less" scoped>
.fee-panel {
  .fee-title {
    .van-cell__title {
      font-size: 14px;
    }

    padding: 5px 15px 0px 15px !important;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/sby-fee-panel.vue